const softWare = () => import("@/pages/syssoft/sysSoftware/sysSoftware.vue");
const wareRole = () => import("@/pages/syssoft/sysSoftwareRole/sysSoftwareRole.vue");

export default [
  {
    path: "/sysSoft/ware",
    name: "softWare",
    component: softWare,
    meta: {
      title: "应用系统",
      noCache: true,
      affix: true,
      path: ["应用系统管理", "应用系统"]
    }
  },
  {
    path: "/sysSoft/wareRole",
    name: "wareRole",
    component: wareRole,
    meta: {
      title: "应用角色关系",
      noCache: true,
      affix: true,
      path: ["应用系统管理", "应用角色关系"]
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/sysSoft.js